import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttachMoneyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attach_money"}/>
}
